export default __webpack_public_path__ + "static/media/overseas_ko.e3f94940.csv";